import { Box } from '@bridebook/ui';
import componentStyles from './carousel-paging.style';

interface IProps {
  imagesCount: number;
  currentIndex: number;
}

const CarouselPaging = ({ imagesCount, currentIndex }: IProps) => {
  const styles = componentStyles(currentIndex, imagesCount);

  return (
    <Box style={styles.wrapper} name="lightweight-carousel-paging">
      <Box style={styles.pagingWrap}>
        <Box style={styles.bullets.wrap} />
        {[...Array(imagesCount)].map((_, index) => (
          <Box style={styles.bullet(index)} key={`${imagesCount}_${index}`} />
        ))}
      </Box>
    </Box>
  );
};

export default CarouselPaging;
